import client from './Client';

export class AppDomain {
  constructor(client) {
    this._client = client;
  }

  /**
   *
   * @returns {boolean}
   */
  isNL() {
    return this._client.getAppDomainId() === 3;
  }

  /**
   * @returns {boolean}
   */
  isHome24() {
    return this._client.getGroup() === 'home24';
  }

  /**
   * @returns {boolean}
   */
  isFashionForHome() {
    return this._client.getGroup() === 'fashionforhome';
  }
}

export default new AppDomain(client);



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/core/AppDomain.js
 **/